import { render, staticRenderFns } from "./darksidead.vue?vue&type=template&id=7b24d4dc&scoped=true"
import script from "./darksidead.vue?vue&type=script&lang=js"
export * from "./darksidead.vue?vue&type=script&lang=js"
import style0 from "./darksidead.vue?vue&type=style&index=0&id=7b24d4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24d4dc",
  null
  
)

export default component.exports